// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const CompareTotalPlays = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.eventInsightsTab.compareTotalPlays"
        description="Compare total plays."
        defaultMessage="Compare with Total Plays"
    />
);
CompareTotalPlays.displayName = "CompareTotalPlays";

export const Filter = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.eventInsightsTab.filter"
        description="Filter."
        defaultMessage="Filter"
    />
);
Filter.displayName = "Filter";

export const SelectAll = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.eventInsightsTab.selectAll"
        description="Select all."
        defaultMessage="Select All"
    />
);
SelectAll.displayName = "SelectAll";

export const DeselectAll = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.eventInsightsTab.deselectAll"
        description="Deselect all."
        defaultMessage="Deselect All"
    />
);
DeselectAll.displayName = "DeselectAll";

export const messages = defineMessages({
    filterSearchPlaceholder: {
        id: "apps.lensInsights.components.eventInsightsTab.filterSearchPlaceholder",
        description: "Filter search placeholder.",
        defaultMessage: "Search events…",
    },
    defaultMetricLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.defaultMetricLabel",
        description: "Default metric label.",
        defaultMessage: " ",
    },
    faceFoundLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.faceFoundLabel",
        description: "Face found label.",
        defaultMessage: "Total Face Found Events",
    },
    faceFoundLabelAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.faceFoundLabelAverage",
        description: "Face found label average.",
        defaultMessage: "Avg # of Faces Found per Session",
    },
    faceFoundFilterLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.faceFoundFilterLabel",
        description: "Face found filter label.",
        defaultMessage: "Face Found Events",
    },
    faceFoundTooltip: {
        id: "apps.lensInsights.components.eventInsightsTab.faceFoundTooltip",
        description: "Face found tooltip.",
        defaultMessage: "Total number of times a Face Found Event is activated in camera",
    },
    faceFoundTooltipAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.faceFoundTooltipAverage",
        description: "Face found tooltip average.",
        defaultMessage: "Average Face Found Events per Lens Play session",
    },
    faceLostLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.faceLostLabel",
        description: "Face lost label.",
        defaultMessage: "Total Face Lost Events",
    },
    faceLostLabelAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.faceLostLabelAverage",
        description: "Face lost label average.",
        defaultMessage: "Avg # of Faces Lost per Session",
    },
    faceLostFilterLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.faceLostFilterLabel",
        description: "Face lost filter label.",
        defaultMessage: "Face Lost Events",
    },
    faceLostTooltip: {
        id: "apps.lensInsights.components.eventInsightsTab.faceLostTooltip",
        description: "Face lost tooltip.",
        defaultMessage: "Total number of times an Face Lost Event is activated in camera",
    },
    faceLostTooltipAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.faceLostTooltipAverage",
        description: "Face lost tooltip average.",
        defaultMessage: "Average Face Lost Events per Lens Play session",
    },
    objectTrackedLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.objectTrackedLabel",
        description: "Object tracked label.",
        defaultMessage: "Total Object Tracked Events",
    },
    objectTrackedLabelAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.objectTrackedLabelAverage",
        description: "Object tracked label average.",
        defaultMessage: "Avg # of Object Tracked per Session",
    },
    objectTrackedFilterLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.objectTrackedFilterLabel",
        description: "Object tracked filter label.",
        defaultMessage: "Object Tracked Events",
    },
    objectTrackedTooltip: {
        id: "apps.lensInsights.components.eventInsightsTab.objectTrackedTooltip",
        description: "Object tracked tooltip.",
        defaultMessage: "Total number of times an Object Tracking Event is activated in camera",
    },
    objectTrackedTooltipAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.objectTrackedTooltipAverage",
        description: "Object tracked tooltip average.",
        defaultMessage: "Average Object Tracked Events per Lens Play session",
    },
    objectTracked3dLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.objectTracked3dLabel",
        description: "Object tracked3d label.",
        defaultMessage: "Total 3D Object Tracked Events",
    },
    objectTracked3dLabelAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.objectTracked3dLabelAverage",
        description: "Object tracked3d label average.",
        defaultMessage: "Avg # of 3D Object Tracked per Session",
    },
    objectTracked3dFilterLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.objectTracked3dFilterLabel",
        description: "Object tracked3d filter label.",
        defaultMessage: "3D Object Tracked Events",
    },
    objectTracked3dTooltip: {
        id: "apps.lensInsights.components.eventInsightsTab.objectTracked3dTooltip",
        description: "Object tracked3d tooltip.",
        defaultMessage: "Total number of times a 3D Object Tracking Event is activated in camera",
    },
    objectTracked3dTooltipAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.objectTracked3dTooltipAverage",
        description: "Object tracked3d tooltip average.",
        defaultMessage: "Average 3D Object Tracked Events per Lens Play session",
    },
    markerTrackedLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.markerTrackedLabel",
        description: "Marker tracked label.",
        defaultMessage: "Total Marker Image Tracked Events",
    },
    markerTrackedLabelAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.markerTrackedLabelAverage",
        description: "Marker tracked label average.",
        defaultMessage: "Avg # of Marker Image Tracked per Session",
    },
    markerTrackedFilterLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.markerTrackedFilterLabel",
        description: "Marker tracked filter label.",
        defaultMessage: "Marker Image Tracked Events",
    },
    markerTrackedTooltip: {
        id: "apps.lensInsights.components.eventInsightsTab.markerTrackedTooltip",
        description: "Marker tracked tooltip.",
        defaultMessage: 'Total number of times a "Marker Image" Tracking Event is activated in camera',
    },
    markerTrackedTooltipAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.markerTrackedTooltipAverage",
        description: "Marker tracked tooltip average.",
        defaultMessage: 'Average "Marker Image" Tracked Events per Lens Play session',
    },
    tapLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.tapLabel",
        description: "Tap label.",
        defaultMessage: "Total Tap Events",
    },
    tapLabelAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.tapLabelAverage",
        description: "Tap label average.",
        defaultMessage: "Avg # of Taps in a Session",
    },
    tapFilterLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.tapFilterLabel",
        description: "Tap filter label.",
        defaultMessage: "Tap Events",
    },
    tapTooltip: {
        id: "apps.lensInsights.components.eventInsightsTab.tapTooltip",
        description: "Tap tooltip.",
        defaultMessage: "Total number of times a user taps on the screen",
    },
    tapTooltipAverage: {
        id: "apps.lensInsights.components.eventInsightsTab.tapTooltipAverage",
        description: "Tap tooltip average.",
        defaultMessage: "Average number of Taps per Lens Play session",
    },
    multiuserSessionSharedLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.multiuserSessionSharedLabel",
        description: "Multiuser session shared label.",
        defaultMessage: "# of Multiuser Sessions Shared",
    },
    multiuserSessionSharedFilterLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.multiuserSessionSharedFilterLabel",
        description: "Multiuser session shared filter label.",
        defaultMessage: "Multiuser Sessions shared Events",
    },
    multiuserSessionSharedTooltip: {
        id: "apps.lensInsights.components.eventInsightsTab.multiuserSessionSharedTooltip",
        description: "Multiuser session shared tooltip.",
        defaultMessage: "Total number of multiuser sessions with users shared",
    },
    multiuserSessionJoinedLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.multiuserSessionJoinedLabel",
        description: "Multiuser session joined label.",
        defaultMessage: "# of Multiuser Sessions joined",
    },
    multiuserSessionJoinedFilterLabel: {
        id: "apps.lensInsights.components.eventInsightsTab.multiuserSessionJoinedFilterLabel",
        description: "Multiuser session joined filter label.",
        defaultMessage: "Multiuser Sessions Joined Events",
    },
    multiuserSessionJoinedTooltip: {
        id: "apps.lensInsights.components.eventInsightsTab.multiuserSessionJoinedTooltip",
        description: "Multiuser session joined tooltip.",
        defaultMessage: "Total number of multiuser sessions with users joined",
    },
});
